
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,

} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import 'devextreme-vue/text-area';


import ServicioGrupoListadoDocumentacionService from '../services/serviciogrupolistadodocumentacion-service';
import GrupoListadoDocumentacionService from '../services/grupolistadodocumentacion-service';



export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,

    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {

            procedimientos: null,
            dataSourceGrupo: null,
            dataSourceSolicitudServicio: null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Listado de Informacion',
                showTitle: true,
                width: 350,
                height: 220,
            },



        };
    },
    created() {

        this.serviciogrupolistadodocumentacionService = new ServicioGrupoListadoDocumentacionService();
        this.grupolistadodocumentacionService = new GrupoListadoDocumentacionService();

    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {
            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: id
            });


            this.serviciogrupolistadodocumentacionService.getServicioGrupoListadoDocumentacion(myJSON).then(data => this.dataSourceSolicitudServicio = data);
            this.grupolistadodocumentacionService.getGrupoListadoDocumentacion().then(data => this.dataSourceGrupo = data);
        },

        deleteRegister(e) {

            let myJSON = JSON.stringify({
                pid: e.data.id,
            });


            this.serviciogrupolistadodocumentacionService.deleteServicioGrupoListadoDocumentacion(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha eliminado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        createRegister(e) {


            let id = this.supplierId;

            let myJSON = JSON.stringify({
                pgrupolistadodocumentacionid: e.data.grupolistadodocumentacionid,
                pservicioid: id,
            });



            this.serviciogrupolistadodocumentacionService.createServicioGrupoListadoDocumentacion(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha creado el registro';
                    this.isVisible = true;

                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }
                this.loadDataInfo();

            });


        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        }
        ,
    },
};
